import {
  Box,
  Button,
  Flex,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

type AlertTemplateModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  area?: string;
  conditions?: string[];
};

export const AlertTemplateModal: React.FC<AlertTemplateModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  area,
  conditions,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "oceanWeatherIntelligence.insightAlert",
  });

  return (
    <Modal
      closeOnOverlayClick={false}
      size={"3xl"}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalCloseButton color="gray.500" />
        <ModalBody py="40px" px="32px" color="black">
          <Flex flexDir={"column"} gap="24px">
            <Flex alignItems="center" gap="24px">
              <Text fontSize="xl">{t("customMessage")}</Text>
            </Flex>

            <Box bg="#F6F6F6" p={5} borderRadius="md">
              <Text color="#086AA9" mb="5px">
                {t("exampleAlert")}
              </Text>
              <Text fontWeight="bold" fontSize="md" mb={3}>
                {`${t("alertIcon")} ${title ?? t("alertTitle")} ${t(
                  "inLocation"
                )} ${area ?? ""}`}
              </Text>
              <Text
                mb={2}
                dangerouslySetInnerHTML={{ __html: t("alertPeriod") as string }}
                color="#484848"
              />
              <Text fontWeight="semibold" mb={1}>
                {t("environmentalConditionsTitle")}
              </Text>
              <List spacing={1} pl={4} mb={3} color="#484848">
                {conditions?.slice(0, 3).map((condition, index) => (
                  <ListItem key={index}>{condition}</ListItem>
                ))}
              </List>
              <Text fontWeight="semibold" mb={1}>
                {t("expectedImpactsTitle")}
              </Text>
              <Text mb={3} color="#484848">
                {description ?? t("possibilityOfImpacts")}
              </Text>
              <Text color="#484848">{t("alertNote")}</Text>
            </Box>

            <Button
              layerStyle="ocean"
              _hover={{ layerStyle: "ocean" }}
              onClick={onClose}
              width="100%"
            >
              {t("gotIt")}
            </Button>
          </Flex>
        </ModalBody>

        <ModalFooter pt={0} pl={2} pr={2} pb={0}></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
